module.exports = __webpack_public_path__ + "img/ico-work.3a361ac3.svg";